import { authenticatedFetch } from '../../../utils/api';

const useRating = ({ userId, setLoading }) => {
    const handleRatingSubmit = async (Rating, LineId, Rl, Feedback) => {
        const data = {
            Rating,
            Feedback,
            LineId,
            Rl,
            EmailAddress: userId
        };
        try {
            const res = await authenticatedFetch('/ManagerReport/FeedbackFromReport', {
                method: 'POST',
                body: JSON.stringify(data)
            });
            if (!res.ok) {
                const response = await res.json();
                window.alert(response.item3 || 'An error occurred whilst submitting feedback.');
            }
        }
        catch (ex) {
            console.log(ex);
        }
        finally {
            setLoading(false);
        }
    };

    return { handleRatingSubmit };
};

export default useRating;
